import React, { useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  PageContainer,
  ModelSelectorAndRecentActivityContainer,
  NotesAndTasksContainer,
  RepairOrdersAndAppointmentsContainer,
  // DealershipTeamAndFISalesContainer,
  Container,
} from "./Overview.styled";
import {
  InformationCards,
  ModelSelector,
  RecentActivity,
  Notes,
  Tasks,
  RepairOrders,
  Appointments,
  // DealershipTeam,
  // FISales,
} from "./components";

const Overview = () => {
  const { contactId } = useParams();
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const handleSelectedVehicleChange = useCallback((vehicle) => {
    setSelectedVehicle(vehicle);
  }, []);

  return (
    <PageContainer>
      <Container>
        <InformationCards />
        <ModelSelectorAndRecentActivityContainer>
          <ModelSelector 
            contactId={contactId} 
            onSelectedVehicleChange={handleSelectedVehicleChange}
          />
          <RecentActivity />
        </ModelSelectorAndRecentActivityContainer>
        <NotesAndTasksContainer>
          <Notes />
          <Tasks />
        </NotesAndTasksContainer>
        <RepairOrdersAndAppointmentsContainer>
          <RepairOrders />
          <Appointments />
        </RepairOrdersAndAppointmentsContainer>
        {/* <DealershipTeamAndFISalesContainer>
          <DealershipTeam />
          <FISales contactId={contactId} selectedVehicle={selectedVehicle} />
        </DealershipTeamAndFISalesContainer> */}
      </Container>
    </PageContainer>
  );
};

export default Overview;
